import { destroy, detach, flow, Instance, types } from 'mobx-state-tree';

import { getMeets, createMeet } from '@common/api/meets';
import PeriodModel from '@common/models/PeriodModel';
import Meet from './ReworkingMeet';
import { getSlotMap, getDaySlotMap } from './constants';

const Meets = types
	.compose(
		PeriodModel,
		types.model({
			data: types.optional(types.array(Meet), []),
			service_id: types.number,
			location_id: types.number,
			teacher_id: types.maybe(types.number),
			limit: 300,
			slotDuration: types.optional(types.number, 30),
		}),
	)
	.named('Meets')
	.views((self) => ({
		get slotsInHour() {
			return Math.trunc(60 / self.slotDuration);
		},
	}))
	.views((self) => ({
		get daysMap() {
			const result = getSlotMap(self.slotsInHour);
			self.data.forEach((item) => {
				result[item.weekday][item.hourNumber][item.hourSlotNumber] = item;
			});
			return result;
		},
		get slotsMap() {
			const result = getDaySlotMap(self.slotsInHour);
			self.data.forEach((item) => {
				result[item.weekday][item.lessonSlotNumber] = item;
			});
			return result;
		},
		get maxHour() {
			return 21;
		},
		get minHour() {
			return 8;
		},
	}))
	.actions((self) => ({
		_fetch: (query: any) =>
			getMeets({
				...query,
				location_id: self.location_id,
				period_start: self.period_start,
				period_end: self.period_end,
				teacher_id: self.teacher_id,
			}),
		addMeet: flow(function* (data: any) {
			const result = yield createMeet({
				location_id: self.location_id,
				service_id: self.service_id,
				teacher_id: self.teacher_id,
				...data,
			});
			self.data.push(result);
		}),
		removeMeet(meet: any) {
			detach(meet);
			destroy(meet);
		},
	}));

export default Meets;

export interface IReworkingMeetsModel extends Instance<typeof Meets> {}
